var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",class:{down:_vm.isDown},style:({'width':_vm.width,'height':_vm.height}),on:{"mousedown":function($event){_vm.isDown = true},"mouseup":function($event){_vm.isDown = false},"mouseleave":function($event){_vm.isDown=false},"click":_vm.click}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }